import { call, put, takeEvery, all, fork } from "redux-saga/effects";

import {
  GET_UNITS,
  CREATE_UNITS,
  UPDATE_UNITS,
  DELETE_UNITS,
  CREATE_DEPARTMENT,
} from "./actionType";

import { UnitsApiResponseSuccess, UnitsApiResponseError } from "./action";

import {
  getUnits as getUnit,
  createUnits as createUnit,
  updateUnits as updateUnit,
  deleteUnits as deleteUnit,
  createDepartment as departmentCreate,
} from "../../helpers/backend_helper";
import { toast } from "react-toastify";
import { notifyError, notifySuccess } from "../../components/notify";

function* getUnits() {
  try {
    const response = yield call(getUnit);
    yield put(UnitsApiResponseSuccess(GET_UNITS, response));
  } catch (error) {
    yield put(UnitsApiResponseError(GET_UNITS, error));
  }
}

function* createUnits(data) {
  try {
    const response = yield call(createUnit, data.payload.data);
    yield put(UnitsApiResponseSuccess(CREATE_UNITS, response));
    notifySuccess("Unidade adicionada com sucesso!");
  } catch (error) {
    yield put(UnitsApiResponseError(CREATE_UNITS, error));
    notifyError("Erro ao adicionar unidade!");
  }
}

function* updateUnits(data) {
  try {
    const response = yield call(updateUnit, data.payload.data);
    yield put(UnitsApiResponseSuccess(UPDATE_UNITS, response));
    notifySuccess("Unidade atualizada com sucesso!");
  } catch (error) {
    yield put(UnitsApiResponseError(UPDATE_UNITS, error));
    notifyError("Erro ao deletar unidade!");
  }
}

function* deleteUnits(data) {
  try {
    const response = yield call(deleteUnit, data.payload.id);
    yield put(UnitsApiResponseSuccess(DELETE_UNITS, response));
    notifySuccess("Unidade deletada com sucesso!");
  } catch (error) {
    yield put(UnitsApiResponseError(DELETE_UNITS, error));
    notifyError("Erro ao deletar unidade!");
  }
}

function* createDepartment(data) {
  try {
    const response = yield call(departmentCreate, data.payload.data);
    yield put(UnitsApiResponseSuccess(CREATE_DEPARTMENT, response));
    notifySuccess("Lotação criada com sucesso!");
  } catch (error) {
    yield put(UnitsApiResponseError(CREATE_DEPARTMENT, error));
    notifyError("Erro ao criar lotação!");
  }
}

export function* watchGetUnits() {
  yield takeEvery(GET_UNITS, getUnits);
}

export function* watchCreateUnits() {
  yield takeEvery(CREATE_UNITS, createUnits);
}

export function* watchUpdateUnits() {
  yield takeEvery(UPDATE_UNITS, updateUnits);
}

export function* watchDeleteUnits() {
  yield takeEvery(DELETE_UNITS, deleteUnits);
}

export function* watchCreateDepartment() {
  yield takeEvery(CREATE_DEPARTMENT, createDepartment);
}

function* UnitsSaga() {
  yield all([fork(watchGetUnits)]);
  yield all([fork(watchCreateUnits)]);
  yield all([fork(watchUpdateUnits)]);
  yield all([fork(watchDeleteUnits)]);
  yield all([fork(watchCreateDepartment)]);
}

export default UnitsSaga;
